import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getSelfUser, removeSelfUserWithToken } from "../../helpers";

interface Props {
  children: React.ReactNode;
  path: string;
}

/** メンバールート */
export function MemberRoute(props: Props) {
  const { children, path } = props;

  const user = getSelfUser();
  let route;
  if (user) {
    route = <Route path={path}>{children}</Route>;
  } else {
    // ユーザー情報をクリアする
    removeSelfUserWithToken();
    route = <Redirect to="/auth/login" />;
  }
  return route;
}
